import { JsEnv } from '../../../core/models/js_env';
import { ItemSearch } from '../models/item_search';
import { ItemSearchJsEnv } from '../models/item_search_js_env';
import { TypedEvent } from '../../../core/typed_event';
import { AdobeAnalyticsData } from '../../../core/models/analytics/adobe_analytics_data';
import { SpecSearchKey } from '../models/item_search_spec';
import MicroModal from 'micromodal';

const IEM_SPEC_MODAL_ID = 'modal-SLPSRC022';

export class ItemSearchAction {
    static readonly UPDATE_EVENT = new TypedEvent<ItemSearchJsEnv>();
    static readonly ITEM_SEARCH_BUTTON_EVENT = new TypedEvent<AdobeAnalyticsData>();
    static readonly ITEM_SEARCH_MODAL_EVENT = new TypedEvent<AdobeAnalyticsData>();
    private static state: ItemSearch;

    static async init(env: JsEnv, containerClass: any) {
        this.state = new ItemSearch(env.PAGE);

        const specKeySizeStr = (<HTMLInputElement>document.getElementById("specSearchKeysSize")).value;
        const specKeySize = +specKeySizeStr;
        let specKeyArray: SpecSearchKey[] = [];
        const mainItemIndexStr = (<HTMLInputElement>document.getElementById("mainItemIndex")).value;
        const mainItemIndex = +mainItemIndexStr;

        for (let i=0; i < specKeySize; ++i) {
          for (let j=mainItemIndex; j < (mainItemIndex + 1); ++j) {
            let chkTitleCode = (<HTMLInputElement>document.getElementById("chkTitleCode" + i + j)).value;
            let chkTitle = (<HTMLInputElement>document.getElementById("chkTitle" + i + j)).value;
            let chkCode = (<HTMLInputElement>document.getElementById("chkCode" + i + j)).value;
            let chkName = (<HTMLInputElement>document.getElementById("chkName" + i + j)).value;
            let searchTitle = (<HTMLInputElement>document.getElementById("searchTitle" + i + j)).value;
            let searchValue = (<HTMLInputElement>document.getElementById("searchValue" + i + j)).value;
            let values = searchValue.split('、');
            values.forEach((valueElement) => {
              let specKey: SpecSearchKey = {
                chkTitleCode : chkTitleCode,
                chkTitle : chkTitle,
                chkCode : chkCode,
                chkName : chkName,
                searchTitle : searchTitle,
                searchValue : valueElement
              }
              specKeyArray.push(specKey);
            });
          }
        }
        let d: SpecSearchKey[] = specKeyArray;
        this.state.setSpecSearchKey(d);

        return new containerClass(this.state.getModel());
    }

    static async disableChanged(event: any){
      var checked = 0;
      var firstCheckedFlg = false;
      const closest = event.target.closest("div.a-checkbox");
      const checkbox = closest.querySelector('input[type=checkbox].spec-checkbox');

       if (checkbox) {
           checkbox.checked = !checkbox.checked;
       }
      const checkBoxes = document.querySelectorAll('input[type=checkbox].spec-checkbox:checked');

      checkBoxes.forEach((elementCheckbox) => {
        let currentSpecCheckbox = elementCheckbox;
        if((currentSpecCheckbox as HTMLInputElement).checked){
          checked++;
          if(!firstCheckedFlg){
            firstCheckedFlg = true;
            let value = (currentSpecCheckbox as HTMLInputElement).value;
            let codes = value.split('_');
            (<HTMLInputElement>document.getElementById('lstSelSpecCd')).value = codes[0];
          }
        }
      });
      if(checked > 0){
        this.state.setIsEnable(true);
      } else{
        this.state.setIsEnable(false);
      }
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }

    static async mouseover(event: any){
      event.currentTarget.style.backgroundColor = "#FDEBD0";
    }

     static async mouseout(event: any){
       event.currentTarget.style.backgroundColor = "#FFFFFF";
     }

     static async openModal(){
       const checkBoxes = document.querySelectorAll('input[type=checkbox].spec-checkbox:checked');

       checkBoxes.forEach((checkbox) => {
         let currentSpecCheckbox = checkbox;
         (currentSpecCheckbox as HTMLInputElement).checked = false
       });

       this.state.setIsEnable(false);
       this.UPDATE_EVENT.trigger(this.state.getModel());

       const target = document.querySelector('.openItemSearchModal') as HTMLElement;
       if(target != null){
         const analyticsData: AdobeAnalyticsData = {
           target: target,
         };
         this.ITEM_SEARCH_MODAL_EVENT.trigger(analyticsData);
       }
       MicroModal.show(IEM_SPEC_MODAL_ID, {});
     }

    static searchButton(){
      const target = document.getElementById('js-item-search-button') as HTMLElement;
      if(target != null){
        const analyticsData: AdobeAnalyticsData = {
          target: target,
        };
        this.ITEM_SEARCH_BUTTON_EVENT.trigger(analyticsData);
      }
    }
}
